import { Box, Skeleton, Stack, Typography, useTheme } from '@mui/material';

export default function ProspectQuoteFromResponseSkeleton() {
    const theme = useTheme();

    return (
        <Box
            sx={{
                borderRadius: '8px',
                padding: '24px',
                margin: '24px',
                border: `1px solid ${theme.palette.neutral.borderColor}`,
                backgroundColor: 'neutral.white',
                display: 'flex',
                flexDirection: 'column',
                gap: '18px',
            }}
        >
            <Typography variant="h2">Quote form responses</Typography>
            <Stack spacing={2}>
                <Skeleton variant="text" width="40%" height={28} />
                <Skeleton variant="text" width="55%" height={24} />
                <Skeleton variant="text" width="50%" height={24} />
                <Skeleton variant="rectangular" height={120} sx={{ borderRadius: '4px' }} />
            </Stack>
        </Box>
    );
}
